import React from "react";
import {Navigate, useLocation} from "react-router-dom";
import {useAuth} from "../context/AuthContext";

const ProtectedRoute = ({children, requireAdmin = false}) => {
    const {user, loading} = useAuth();
    const location = useLocation();

    if (loading) {
        return <div className="wrap"><h1>Loading...</h1></div>;
    }

    if (!user) {
        return <Navigate to="/login" replace state={{from: location}}/>;
    }

    if (requireAdmin && user.role !== "admin") {
        return <Navigate to="/" replace/>;
    }

    return children;
};

export default ProtectedRoute;
